const HeroNews = (props) => {

  const {
    imageShape,
    blogPost,
    date,
    tags,
    title,
    description,
    image 
  } = props

  const normalizedData = {
    imageShape,
    blogPost,
    date,
    tags,
    title,
    description,
    image
  }

  return normalizedData
}

export default HeroNews
